import { Grid } from '@mui/material';

export interface panelItem {
    component: React.ReactElement;
    grid?: {
        xs?: number;
        sm?: number;
        md?: number;
        lg?: number;
    };
    minHeight?: string | number;
    name?: string;
}

const OverviewItem = ({ grid, minHeight, component, name }: panelItem) => {
    return (
        <Grid
            item
            {...grid}
            minHeight={minHeight}
            data-testid={`${name || 'overview'}-panel`}>
            {component}
        </Grid>
    );
};

export default OverviewItem;
